import React, { useEffect, useState } from "react";
import { checkGroupId } from "../../../utils/commonFunctions";
import { useLocation } from "react-router-dom";

const ResultButtons = props => {

  const { isFinish, history, handleClickButtons } = props;

  const [mode, setMode] = useState(null);

  const location = useLocation();

  useEffect(() => {
    if (history.length > 0) {
      const data = location.state
      if (data?.from_chat) {
        setMode(data?.from_chat)
      }
    }
  }, [location])

  return (
    <div className={`loading-result ${isFinish ? 'show' : 'hide'}`}>
      <div onClick={handleClickButtons} className={`result-btns flx-box fourth ${history[history.length - 1].question_count === 1 ? 'fourth' : ''}`}>
        <div className="crs-btnlink-to-result crs-btn positive-btn" id="result-page" data-mode={mode}>✨ 결과보기</div>
        {/* {
          mode === 'group' &&
          <div className="crs-btn link-to-reset crs-btn negative-btn" id="reset-page" data-mode={mode}>💪 다시 면접보기</div>
        } */}
      </div>
    </div>
  )
}

export default ResultButtons;